module.exports = __webpack_public_path__ + "static/media/features1b.4c70a898.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/features1b.png
 ** module id = 898
 ** module chunks = 0
 **/